import { render, staticRenderFns } from "./SimplePdfViewer.vue?vue&type=template&id=77a2f3ad&scoped=true"
import script from "./SimplePdfViewer.vue?vue&type=script&lang=js"
export * from "./SimplePdfViewer.vue?vue&type=script&lang=js"
import style0 from "./SimplePdfViewer.vue?vue&type=style&index=0&id=77a2f3ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a2f3ad",
  null
  
)

export default component.exports